// Handle variant pill selection
document.querySelectorAll('.variant-pill').forEach(pill => {
  pill.addEventListener('click', function() {
    // Remove 'selected' class from all pills in this product
    this.closest('.variant-pills').querySelectorAll('.variant-pill').forEach(pill => pill.classList.remove('selected'));
    
    // Add 'selected' class to the clicked pill
    this.classList.add('selected');
    
    // Get the selected variant id
    const selectedVariantId = this.getAttribute('data-variant-id');
    
    // Update the quick add button with the selected variant id
    this.closest('.complementary-product').querySelector('.quick-add-button').setAttribute('data-variant-id', selectedVariantId);
  });
});

// Handle adding the selected variant to the cart
document.querySelectorAll('.quick-add-button').forEach(button => {
  button.addEventListener('click', function() {
    const variantId = this.getAttribute('data-variant-id');
    
    // Check if a variant is selected before adding to cart
    if (!variantId) {
      alert('Please select a variant');
      return;
    }
    
    // Send the POST request to Shopify's cart API to add the product with the selected variant
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Success message (you can customize this or add a cart drawer update)
      alert('Product added to cart!');
    })
    .catch(error => {
      // Handle error (optional: show a custom error message)
      console.error('Error:', error);
      alert('Error adding product to cart.');
    });
  });
});
